import { render, staticRenderFns } from "./TableDynamicLocal.vue?vue&type=template&id=7b8f7eaa&scoped=true&"
import script from "./TableDynamicLocal.vue?vue&type=script&lang=js&"
export * from "./TableDynamicLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8f7eaa",
  null
  
)

export default component.exports